import type { DayRange } from '@api/types'
import type { Locale } from '@i18n/locale'

// Día AAAA-MM-DD en hora peninsular: la API cuenta los periodos así (spec `monitoring`).
export const madridDay = (date: Date): string =>
	new Intl.DateTimeFormat('en-CA', {
		timeZone: 'Europe/Madrid',
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	}).format(date)

// Los últimos `days` días, hoy incluido (p. ej. 30 → de hace 29 días a hoy).
export const lastDays = (days: number, now: Date = new Date()): DayRange => {
	const span = Math.max(1, Math.floor(days))
	const today = madridDay(now)
	const [y, m, d] = today.split('-').map(Number) as [number, number, number]
	const from = new Date(Date.UTC(y, m - 1, d - (span - 1)))
	return { from: from.toISOString().slice(0, 10), to: today }
}

// Las últimas `weeks` semanas completas de lunes a domingo, la actual incluida (aunque vaya por
// la mitad): así la participación por semana trae exactamente `weeks` barras.
export const lastWeeks = (weeks: number, now: Date = new Date()): DayRange => {
	const span = Math.max(1, Math.floor(weeks))
	const today = madridDay(now)
	const [y, m, d] = today.split('-').map(Number) as [number, number, number]
	const sinceMonday = (new Date(Date.UTC(y, m - 1, d)).getUTCDay() + 6) % 7
	const from = new Date(Date.UTC(y, m - 1, d - sinceMonday - 7 * (span - 1)))
	return { from: from.toISOString().slice(0, 10), to: today }
}

// Fecha y hora de un aviso en el idioma del panel (p. ej. "13 oct 2026, 18:05").
export const formatDateTime = (iso: string, locale: Locale): string =>
	new Intl.DateTimeFormat(locale, {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
		timeZone: 'Europe/Madrid',
	}).format(new Date(iso))

// Inicio de un periodo de la participación (AAAA-MM-DD) como etiqueta corta: "13 oct".
export const formatPeriodStart = (day: string, locale: Locale): string =>
	new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short', timeZone: 'UTC' }).format(
		new Date(`${day}T00:00:00Z`)
	)
